import React, { FC, memo, useCallback, useMemo } from 'react';
import { deleteUser } from '../../../api/fetch-functions/user';
import { viewTexts } from '../../../constants/view-texts';
import { useToken } from '../../../global-state/auth-state';
import { fetchUserList } from '../../../global-state/database/user-list';
import { IUserType } from '../../../types/record/user';
import { ConfirmDeleteDialogTemplate } from '../confirm-delete-dialog-template/confirm-delete-dialog-template';

const vt = viewTexts.dialogs.deleteUser;

interface Props {
  open: boolean;
  onClose: (reason: 'ok' | 'cancel' | '') => void;
  user: IUserType;
}

export const DeleteUserDialog: FC<Props> = memo(
  ({ open, onClose, user: userInit }: Readonly<Props>) => {
    const message = useMemo<string[]>(() => vt.message(userInit.name), [
      userInit.name
    ]);

    /* event handler */

    const token = useToken();

    const closeOnClick = useCallback(
      (reason: 'yes' | 'no') => {
        if (reason === 'no') {
          onClose('cancel');
        } else {
          if (token !== undefined && userInit.name !== undefined) {
            deleteUser(token)(userInit.id).then(res => {
              if (res.type === 'success') {
                onClose('ok');
                fetchUserList();
              }
            });
          }
        }
      },
      [onClose, userInit, token]
    );

    return (
      // TODO: 待機状態のUIを作る
      <ConfirmDeleteDialogTemplate
        title={vt.title}
        messages={message}
        open={open}
        onClose={closeOnClick}
      />
    );
  }
);

DeleteUserDialog.displayName = 'DeleteUserDialog';
